import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types'; // eslint-disable-line no-unused-vars
import styled from 'styled-components';
import View from 'components/View';

const Container = styled(View)`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding-left: 64px;
  padding-right: 64px;
`;

Container.propTypes = {

};

export default Container;
